import React, { useEffect, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import 'react-datepicker/dist/react-datepicker.css';
import { isSameDay, setHours, setMinutes } from 'date-fns';
import Icon from '../../../components/AppIcon';

registerLocale('fr', fr);

const ContactDateTimePicker = ({ value, onChange }) => {
    const allowedDate = new Date(); // Jeudi
    const allowedStart = setHours(setMinutes(new Date(allowedDate), 30), 16); // 16h30

    const isDateAllowed = (date) => {
        const now = new Date();
        const day = date.getDay(); // 0 = dimanche, 6 = samedi
        return day !== 0 && day !== 6 && date.setHours(0, 0, 0, 0) >= now.setHours(0, 0, 0, 0);
    };

    const isTimeAllowed = (time) => {
        const now = new Date();
        const selectedDate = new Date(value || initialDate);
        const t = new Date(time);
        const hours = t.getHours();

        const inRange = hours >= 10 && hours < 18;

        // si le jour est aujourd'hui → interdit si avant +5 min
        if (selectedDate.toDateString() === now.toDateString()) {
            return inRange && time > new Date(now.getTime() + 5 * 60000);
        }

        return inRange;
    };

    const getNextAvailableSlot = (interval = 5) => {
        const now = new Date();
        now.setSeconds(0, 0);

        let candidate = new Date(now);

        const roundedMinutes = Math.ceil(candidate.getMinutes() / interval) * interval;
        candidate.setMinutes(roundedMinutes);

        while (true) {
            const day = candidate.getDay();
            const hour = candidate.getHours();

            const isWeekday = day !== 0 && day !== 6;
            const isAfterNow = candidate.getTime() > now.getTime() + 5 * 60 * 1000;
            const inHourRange = hour >= 10 && hour < 18;

            if (isWeekday && isAfterNow && inHourRange) {
                return candidate;
            }

            candidate = new Date(candidate.getTime() + interval * 60 * 1000); // +5min
        }
    };

    const [initialDate] = useState(getNextAvailableSlot());
    useEffect(() => {
        if (!value) onChange(initialDate);
    }, [value]);

    return (
        <div className="space-y-2 w-full">
            <label className="block text-sm font-medium text-text-primary font-inter mb-1">
                Créneau de contact souhaité *
            </label>

            <div className="relative w-full">
                <DatePicker
                    locale="fr"
                    selected={value || initialDate}
                    onChange={onChange}
                    showTimeSelect
                    timeIntervals={5}
                    dateFormat="EEEE dd MMMM yyyy HH:mm"
                    placeholderText="Choisissez votre créneau"
                    filterTime={isTimeAllowed}
                    filterDate={isDateAllowed}
                    minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                    calendarClassName="!bg-white !rounded-xl !shadow-lg !border !border-gray-200 !p-4 font-inter text-sm"
                    dayClassName={(date) => {
                        const selected = value || initialDate;
                        const isSelected = date.getDate() === selected.getDate();
                        return `!w-9 !p-1 !rounded-lg hover:!bg-primary hover:!text-white ${isSelected ? '!bg-primary !text-white' : ''}`;
                    }}
                    timeCaption="Heure"
                    renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                        <div className="flex justify-between items-center mb-2 px-2 text-primary font-semibold">
                            <button onClick={decreaseMonth} type="button">‹</button>
                            <span>{date.toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' })}</span>
                            <button onClick={increaseMonth} type="button">›</button>
                        </div>
                    )}
                    timeClassName={(time) => {
                        const selected = value || initialDate;
                        const isSelected = new Date(time).getHours() === new Date(selected).getHours()
                            && new Date(time).getMinutes() === new Date(selected).getMinutes();
                        return ` !rounded-lg hover:!bg-primary hover:!text-white ${isSelected ? '!bg-primary !text-white' : ''}`;
                    }}

                    // 🔥 Ici on force 100% de largeur
                    wrapperClassName="w-full"
                    className="block w-full pr-10 border border-border-light rounded-lg px-5 py-3 text-base focus:ring-2 focus:ring-primary focus:outline-none font-inter"
                />

                <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                    <Icon name="Calendar" size={22} color="#9CA3AF" />
                </div>
            </div>
            <p className="text-xs text-text-secondary font-inter">
                Nous utiliserons le créneau mentionné pour vous contacter.
            </p>
        </div>
    );
};

export default ContactDateTimePicker;